/**
 * Quantas vezes a preparação do pacote terminou desde a abertura da mesa (E206.F3, GUS-296 item 4).
 *
 * O documento da mesa é lido uma vez e relido quando a mesa grava. Aberta durante a preparação, a
 * mesa podia ficar com a resposta "sem resultado" (ou a falha) de antes de a análise existir: o
 * número muda quando `preparando` passa de verdadeiro a falso, e o documento é relido.
 */
import { useRef } from 'react';

import type { PreparacaoDoPacote } from '@/lib/usePreparacaoDoPacote';

export function useFimDaPreparacao(leitura: PreparacaoDoPacote['leitura']): number {
  const preparando = leitura.estado === 'pronto' && leitura.dados.preparando;
  const anterior = useRef(preparando);
  const fins = useRef(0);
  if (anterior.current && !preparando) fins.current += 1;
  anterior.current = preparando;
  return fins.current;
}
